// What a skill/migration DOES to the org — the decision-relevant signal for the
// catalog card (replaces the old, meaningless "Better/Good" quality verdict).
// Read-only skills only inspect; "makes changes" skills generate code/config to deploy.
const WRITE_CATEGORIES = new Set(["migration", "refactor", "build", "codegen"]);

export function skillImpact(category?: string | null): { label: string; writes: boolean } {
  const writes = WRITE_CATEGORIES.has((category ?? "").toLowerCase());
  return { label: writes ? "Makes changes" : "Read-only", writes };
}
